"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyAddressesAttributes$ = exports.PropertyAddressesAttributes$outboundSchema = exports.PropertyAddressesAttributes$inboundSchema = void 0;
exports.propertyAddressesAttributesToJSON = propertyAddressesAttributesToJSON;
exports.propertyAddressesAttributesFromJSON = propertyAddressesAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const addresses_js_1 = require("./addresses.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const mappoints_js_1 = require("./mappoints.js");
/** @internal */
exports.PropertyAddressesAttributes$inboundSchema = z.object({
    address: addresses_js_1.Addresses$inboundSchema,
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$inboundSchema),
    map_points: z.nullable(mappoints_js_1.MapPoints$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "map_points": "mapPoints",
    });
});
/** @internal */
exports.PropertyAddressesAttributes$outboundSchema = z.object({
    address: addresses_js_1.Addresses$outboundSchema,
    location: z.nullable(geopointlocation_js_1.GeoPointLocation$outboundSchema),
    mapPoints: z.nullable(mappoints_js_1.MapPoints$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        mapPoints: "map_points",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyAddressesAttributes$;
(function (PropertyAddressesAttributes$) {
    /** @deprecated use `PropertyAddressesAttributes$inboundSchema` instead. */
    PropertyAddressesAttributes$.inboundSchema = exports.PropertyAddressesAttributes$inboundSchema;
    /** @deprecated use `PropertyAddressesAttributes$outboundSchema` instead. */
    PropertyAddressesAttributes$.outboundSchema = exports.PropertyAddressesAttributes$outboundSchema;
})(PropertyAddressesAttributes$ || (exports.PropertyAddressesAttributes$ = PropertyAddressesAttributes$ = {}));
function propertyAddressesAttributesToJSON(propertyAddressesAttributes) {
    return JSON.stringify(exports.PropertyAddressesAttributes$outboundSchema.parse(propertyAddressesAttributes));
}
function propertyAddressesAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyAddressesAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyAddressesAttributes' from JSON`);
}
//# sourceMappingURL=propertyaddressesattributes.js.map